"use strict";

var _slicedToArray = require("/home/circleci/repo/web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var _require = require('nano-css'),
    create = _require.create;

var _require2 = require('nano-css/addon/cssom'),
    addonCssom = _require2.addon;

var _require3 = require('nano-css/addon/pipe'),
    addonPipe = _require3.addon;

var flattenSelectors = function flattenSelectors(css) {
  var flatenned = {};
  var amp = {};
  var hasAmp = false;

  for (var key in css) {
    var value = css[key];

    if (typeof value === 'object') {
      flatenned[key] = value;
    } else {
      hasAmp = true;
      amp[key] = value;
    }
  }

  if (hasAmp) {
    flatenned['&'] = amp;
  }

  return flatenned;
};

var nano = create();
addonCssom(nano);
addonPipe(nano);

var useCss = function useCss(css) {
  var _react_1$useState = react_1.useState(nano.pipe()),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 1),
      pipe = _react_1$useState2[0];

  react_1.useEffect(function () {
    pipe.css(flattenSelectors(css));
    return function () {
      return pipe.remove();
    };
  });
  return pipe.className;
};

exports.default = useCss;